import PropTypes from 'prop-types';
import BillingCategoryType from './billingCategoryType';
import BillingContactType from './billingContactType';

const BillingItemAmountType = PropTypes.shape({
  id: PropTypes.string,
  amount: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  billing_category_id: PropTypes.string,
  billing_contact_id: PropTypes.string,
  billing_category: BillingCategoryType,
  billing_contact: BillingContactType,
  errors: PropTypes.object
});

export default BillingItemAmountType;
